const getObjFromQueryString = (str) => {
    const urlParams = new URLSearchParams(str);
    const result = {};
    for (const pair of urlParams.entries()) {
        result[pair[0]] = pair[1];
    }
    return result;
};
const regexes = [
    {
        regex: /-s([A-Za-z0-9._-]{1,20})\.html/,
        pathname: '/products/[sku]',
        paramName: 'sku',
    },
    {
        regex: /--s([A-Za-z0-9._-]{1,20})/,
        pathname: '/products/[sku]',
        paramName: 'sku',
    },
    {
        regex: /-(.*)\.cat/,
        pathname: '/categories/[categoryId]',
        paramName: 'categoryId',
    },
    {
        regex: /-c([0-9]{1,})/,
        pathname: '/categories/[categoryId]',
        paramName: 'categoryId',
    },
    {
        regex: /-cat\.(.*)/,
        pathname: '/block-categories/[categoryId]',
        paramName: 'categoryId',
    },
    {
        regex: /-sel\.(.*)/,
        pathname: '/sellers/[sellerId]',
        paramName: 'sellerId',
    },
    {
        regex: /-brand\.(.*)/,
        pathname: '/brands/[brandId]',
        paramName: 'brandId',
    },
];
const extractFromPath = (path) => {
    for (const reg of regexes) {
        const matchResult = path.match(reg.regex);
        if (matchResult) {
            return {
                pathname: reg.pathname,
                query: {
                    [reg.paramName]: matchResult[1],
                },
            };
        }
    }
    return path;
};

const isValidEmailFormat = (email) => {
    const regex = /^.*@\w+\.\w+.*$/;
    return regex.test(email);
};
const isValidPhoneFormat = (number) => {
    if (!number.match(/^((09|03|07|08|05)+([0-9]{8}))$/) &&
        !number.match(/^(\+(84)+(09|03|07|08|05)+([0-9]{8}))$/) &&
        !number.match(/^(\+(84)+(9|3|7|8|5)+([0-9]{8}))$/) &&
        !number.match(/^((84)+(09|03|07|08|05)+([0-9]{8}))$/) &&
        !number.match(/^((84)+(9|3|7|8|5)+([0-9]{8}))$/)) {
        return false;
    }
    return true;
};
const PATTERN_VALIDATION = {
    email: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
    phone: /^([+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b$/,
    vietnameseName: /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ\s\w|_]+$/,
};

const getWeekdayOfDate = (date) => {
    const weekday = [
        'Chủ nhật',
        'Thứ hai',
        'Thứ ba',
        'Thứ tư',
        'Thứ năm',
        'Thứ sáu',
        'Thứ bảy',
    ];
    const n = weekday[date.getDay()];
    return n;
};

const htmlEncode = (html) => {
    return html.replace(/[\u00A0-\u9999<>\&]/g, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
};
const htmlDecode = (str) => {
    const e = document.createElement('textarea');
    e.innerHTML = str;
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
};

const isFloat = (n) => Number(n) === n && n % 1 !== 0;

const normalizePhone = (rawphone) => {
    const phone = rawphone.trim();
    if (phone.length > 10) {
        if (phone.startsWith('84'))
            return phone.replace('84', '0');
        if (phone.startsWith('+84'))
            return phone.replace('+84', '0');
        return phone;
    }
    return phone;
};
const customizedMessage = (message, fields) => {
    let resultMessage = message;
    fields.forEach(({ name, value }) => {
        const regex = new RegExp(`{${name}}`, 'g');
        resultMessage = resultMessage.replace(regex, value);
    });
    return resultMessage;
};
const inIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
const toObject = (arr, keyField) => {
    let newArr = {};
    if (Array.isArray(arr)) {
        for (const key in arr) {
            newArr = Object.assign(Object.assign({}, newArr), { [arr[key][keyField]]: arr[key] });
        }
    }
    return newArr;
};
const cleanObject = (object) => {
    const newObj = {};
    Object.keys(object).forEach((key) => {
        if (object[key] || object[key] === false || object[key] === 0) {
            newObj[key] = object[key];
        }
    });
    return newObj;
};
const formatCurrency = (money, isFull = true) => {
    return money
        ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') +
            `${isFull ? 'đ' : ''}`
        : `${money}`;
};
function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

export { PATTERN_VALIDATION, cleanObject, customizedMessage, debounce, extractFromPath, formatCurrency, getObjFromQueryString, getWeekdayOfDate, htmlDecode, htmlEncode, inIframe, isFloat, isValidEmailFormat, isValidPhoneFormat, normalizePhone, toObject };
